"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OwnershipType = void 0;
var OwnershipType;
(function (OwnershipType) {
    OwnershipType["OWNED"] = "OWNED";
    OwnershipType["SHARED"] = "SHARED";
    OwnershipType["ALL"] = "ALL";
})(OwnershipType = exports.OwnershipType || (exports.OwnershipType = {}));
